import React from "react";
import { FormikValues } from "formik";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import { useFinalisation } from "src/pages/finalisation/FinalisationContext";
import { VerificationTelephone } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/useValidationSchemaTelephone";
import AppCol from "src/commun/composants/grille/AppCol";
import AppRow from "src/commun/composants/grille/AppRow";
import { useAppText } from "src/commun/composants/AppText";
import CodeTelephoneSendForm from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/CodeTelephoneSendForm";

export type VerificationTelephoneContainerProps = {
  initialValues: VerificationTelephone;
  stepSuivante: () => void
  pageSuivante: (data: any) => void;
};

const CodeTelephoneSendContainer = ({ initialValues, stepSuivante, pageSuivante }: VerificationTelephoneContainerProps) => {
  const { tString } = useAppText();
  const [value, api] = useFinalisation();

  const submitSuccessHandler = (result: GenericApiResponse<any>, values: FormikValues) => {
    const etapes = [...value.etapes];
    etapes[1].data = values;
    api.setEtapes(etapes);
    stepSuivante();
  };

  return (
    <AppRow>
      <AppCol md={7}>
        <label>{tString("migration.step.2.intro")}</label>
        <label className="mt-3">{tString("compte.saisie.mobile.message.1")}</label>
        <label className="mt-3">{tString("compte.saisie.mobile.message.2")}</label>
      </AppCol>
      <AppCol md={5}>
        <CodeTelephoneSendForm initialValues={initialValues} submitSuccessHandler={submitSuccessHandler} canSkip={true} pageSuivante={pageSuivante}/>
      </AppCol>
    </AppRow>
  );
};

export default CodeTelephoneSendContainer;